import React from 'react';
import { Target, Search, Layout, Lightbulb, ArrowRight } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from './ui/card';
import { Button } from './ui/button';

const Services = () => {
  const iconMap = {
    target: Target,
    search: Search,
    layout: Layout,
    lightbulb: Lightbulb
  };

  const services = [
    {
      id: 1,
      title: "Meta Ads Management",
      description: "Strategic Facebook & Instagram advertising campaigns that drive measurable results and maximize your ROI.",
      features: [
        "Campaign strategy & setup",
        "Audience targeting & segmentation",
        "Creative optimization & A/B testing",
        "Performance tracking & reporting"
      ],
      icon: "target"
    },
    {
      id: 2,
      title: "Google Ads Management",
      description: "Data-driven Google Ads campaigns across Search, Display, and Shopping networks to capture high-intent customers.",
      features: [
        "Keyword research & optimization",
        "Ad copy creation & testing",
        "Bid management & budget optimization",
        "Conversion tracking & analytics"
      ],
      icon: "search"
    },
    {
      id: 3,
      title: "Landing Page Creation",
      description: "High-converting landing pages designed to transform visitors into customers with compelling design and copy.",
      features: [
        "Conversion-focused design",
        "Mobile-responsive layouts",
        "A/B testing & optimization",
        "Fast loading & SEO optimized"
      ],
      icon: "layout"
    },
    {
      id: 4,
      title: "Marketing Consulting",
      description: "Strategic guidance and expert advice to elevate your entire digital marketing ecosystem and drive growth.",
      features: [
        "Marketing strategy development",
        "Campaign audit & optimization",
        "Team training & workshops",
        "Growth roadmap planning"
      ],
      icon: "lightbulb"
    }
  ];

  return (
    <section className="py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold mb-6" style={{ fontFamily: "'Crimson Text', serif" }}>
            Services That Drive Results
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Comprehensive digital marketing solutions tailored to your business goals.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service) => {
            const Icon = iconMap[service.icon];
            return (
              <Card 
                key={service.id} 
                className="bg-white hover:shadow-2xl transition-all duration-300 hover:translate-y-[-4px] border-2 border-gray-200 hover:border-black"
              >
                <CardHeader>
                  <div className="w-14 h-14 bg-black rounded-lg flex items-center justify-center mb-4">
                    <Icon className="h-7 w-7 text-white" />
                  </div>
                  <CardTitle className="text-2xl mb-3" style={{ fontFamily: "'Crimson Text', serif" }}>
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-base text-gray-700">
                    {service.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-3">
                    {service.features.map((feature, index) => (
                      <li key={index} className="flex items-start gap-3">
                        <ArrowRight className="h-5 w-5 text-black mt-0.5 flex-shrink-0" />
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="text-center mt-12">
          <Button 
            onClick={() => window.open('https://calendly.com/digitalcoachshyam/startegy-call', '_blank')}
            className="bg-black text-white hover:bg-gray-800 px-8 py-6 text-lg font-semibold rounded-lg transition-all duration-200 hover:translate-y-[-2px] hover:shadow-lg"
          >
            Discuss Your Project
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Services;
